<nav
  class="
    navbar navbar-expand-sm navbar-toggleable-sm navbar-light
    bg-white
    navbar-admin-console-menu
  "
>
  <div class="container">
    <button class="navbar-toggler" type="button">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse">
      <ul id="navbar-nav" class="navbar-nav flex-grow-1">
        <li class="nav-item">
          <a
            class="nav-link text-dark clsMenuOption clsOpenDiv"
            [ngClass]="{
              clsMenuSelect:
                selectedSection === apps
            }"
            [routerLink]="[apps]"
            (click)="sectionClick(apps)"
          >
            <em class="mnu mnu-apps"></em>
            <span class="hide-menu">{{
              'component.sections.apps' | translate | uppercase
            }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link text-dark clsMenuOption clsOpenDiv"
            [ngClass]="{
              clsMenuSelect:
                selectedSection === security
            }"
            [routerLink]="[security]"
            (click)="sectionClick(security)"
          >
            <em class="mnu mnu-security"></em>
            <span class="hide-menu">{{
              'component.sections.security' | translate | uppercase
            }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
